import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppService } from '../../../../app/app.service';
import { TranslateService } from '../../../../app/translate';
import { NewInspectionService } from '../../inspection/services/new-inspection.service';
import { LoadingService } from '../../../../app/shared/services/loading.service';
import { MatDialog } from '@angular/material/dialog';import { SetupEquipmentService } from '../../setup-equipment/setup-equipment.service';
import { Subscription } from 'rxjs/Subscription';
import { CustomEvalService } from '../custom-eval.service';
import { CustomEvalLevelsVM, UserAccessType, FilteredListVm, CustomeEvaluationRangeVM, ApplyToAllCompsVm, EquipmentForSelectionVM, ApplyToAllCompsEquipmentsVm, EquipmentRanges, DeleteEquipemntRangeVM } from '../custom-eval.model';
import { UserService } from '../../../../app/shared/services/user.service';
import { concatAll } from 'rxjs/operators';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';
import { SearchItem } from '../../../../app/entities';
import { OrderInspectionBy } from '../../inspection/models/find-inspection.model';
import { DeleteConfirmationDialogComponent } from '../../rope-shovel/components/delete-confirmation-dialog/delete-confirmation-dialog.component';
import { CustomEvalDeleteConfirmComponent } from '../Components/custom-eval-delete-confirm/custom-eval-delete-confirm.component';
import { ConfirmationBoxComponent } from '../../../shared/confirmation-box/confirmation-box.component';

@Component({
  selector: 'app-manage-custom-eval',
  templateUrl: './manage-custom-eval.component.html',
  styleUrls: ['./manage-custom-eval.component.scss']
})
export class ManageCustomEvalComponent implements OnInit {

  A_to:number;
  B_from:string;
  B_to:number ;
  C_from:string;
  C_to:number ;
  X_from:string;

  IsDefault:boolean=false;

  selectedValue:number;
  selecetedLevel:number;
  //ComponentRanges

  LinkA_to:number;
  LinkB_from:string;
  LinkB_to:number;
  LinkC_from:string;
  LinkC_to:number;
  LinkX_from:string;
  ChangeExcludeC_LinkC:boolean;
  isCExclude_Link:boolean;

  BushA_to:number;
  BushB_from:string;
  BushB_to:number;
  BushC_from:string;
  BushC_to:number;
  BushX_from:string;
  ChangeExcludeC_BushC:boolean;
  isCExclude_Bush:boolean;


  ShoeA_to:number;
  ShoeB_from:string;
  ShoeB_to:number;
  ShoeC_from:string;
  ShoeC_to:number;
  ShoeX_from:string;
  ChangeExcludeC_ShoeC:boolean;
  isCExclude_Shoe:boolean;


  SprocketA_to:number;
  SprocketB_from:string;
  SprocketB_to:number;
  SprocketC_from:string;
  SprocketC_to:number;
  SprocketX_from:string;
  ChangeExcludeC_SprocketC:boolean;
  isCExclude_Sprocket:boolean;


  IdlerA_to:number;
  IdlerB_from:string;
  IdlerB_to:number;
  IdlerC_from:string;
  IdlerC_to:number;
  IdlerX_from:string;
  ChangeExcludeC_IdlerC:boolean;
  isCExclude_Idler:boolean;


  TrackRollerA_to:number;
  TrackRollerB_from:string;
  TrackRollerB_to:number;
  TrackRollerC_from:string;
  TrackRollerC_to:number;
  TrackRollerX_from:string;
  ChangeExcludeC_TrackRollerC:boolean;
  isCExclude_TrackRoller:boolean;


  CarrierRollerA_to:number;
  CarrierRollerB_from:string;
  CarrierRollerB_to:number;
  CarrierRollerC_from:string;
  CarrierRollerC_to:number;
  CarrierRollerX_from:string;
  ChangeExcludeC_CarrierRollerC:boolean;
  isCExclude_CarrierRoller:boolean;


  RSRearIdlerA_to:number;
  RSRearIdlerB_from:string;
  RSRearIdlerB_to:number;
  RSRearIdlerC_from:string;
  RSRearIdlerC_to:number;
  RSRearIdlerX_from:string;
  ChangeExcludeC_RSRearIdlerC:boolean;
  isCExclude_RSRearIdler:boolean;


  CrawlerGuideA_to:number;
  CrawlerGuideB_from:string;
  CrawlerGuideB_to:number;
  CrawlerGuideC_from:string;
  CrawlerGuideC_to:number;
  CrawlerGuideX_from:string;
  ChangeExcludeC_CrawlerGuideC:boolean;
  isCExclude_CrawlerGuide:boolean;


  ElongationA_to:number;
  ElongationB_from:string;
  ElongationB_to:number;
  ElongationC_from:string;
  ElongationC_to:number;
  ElongationX_from:string;
  ChangeExcludeC_ElongationC:boolean;
  isCExclude_Elongation:boolean;


  GeneralA_to:number;
  GeneralB_from:string;
  GeneralB_to:number;
  GeneralC_from:string;
  GeneralC_to:number;
  GeneralX_from:string;
  ChangeExcludeC_GeneralC:boolean;
  isCExclude_General:boolean;



  InValid:boolean=false;
  isCExclude:boolean=false;
  EvalLevels:CustomEvalLevelsVM[]=[];


CustomSelectRanges:CustomeEvaluationRangeVM=null;
isLevelSelect:boolean=false;
isEquipmentLevelSelect:boolean=false;

_currentUserJobRoles : string[] = [];
userAccessType: UserAccessType;

selectValue:boolean=false;
hasDealers:boolean=false;
hasCustomers:boolean=false;
hasJobsites:boolean=false;
hasEquipments:boolean=false;

selectAllEquipments:boolean=false;
EquipmentRanges:EquipmentRanges[]=[];
Ranges:DeleteEquipemntRangeVM =null;
showWval:boolean=false;
levelName:string="";
FiteredList:FilteredListVm[]=[];
FiteredCustomerList:FilteredListVm[]=[];
FiteredJobsiteList:FilteredListVm[]=[];

  translateSubscription: Subscription;
  userLanguage = 'english';
  selectedTab = 0;
  constructor(
    private _appService: AppService,
    private _translate: TranslateService,
    private ref: ChangeDetectorRef,
    private _inspectionService: NewInspectionService,
    private _loading: LoadingService,
    private _dialog: MatDialog,
    private _equipmentService: SetupEquipmentService,
    private _evalService: CustomEvalService,
    private _userService: UserService,
    private _notification: NotificationsService,
    public readonly _router: Router
  ) { }

  ngOnInit() {
    this._appService.setPageTitle('Manage Custom Evaluation');
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));

  //   this._userService.getUserAccessType().subscribe(response => {
  //     this.userAccessType = response;
  //     this._evalService.getUserJobRoles().subscribe(response => {
  //         this._currentUserJobRoles.push(...response);
  //         this.setVisibleComponentsForUser();
  //     });
  //     //this.loadingData = false;
  // });

    this.LoadEvaluationLevels();


    //equipment
    this.initializeSearch();


  }

  OpenDeleteEquipmentConfirm() {
    const newdeleteDialog = this._dialog.open(CustomEvalDeleteConfirmComponent, {
        //panelClass: 'removeModalOverflow',

        data: {
            selectedEquipment: this.selectedEquipmentList
        },
        
          height:'700px',
    });

    newdeleteDialog.afterClosed().subscribe(result => {
      this.GetRangeFromDB(this.selecetedLevel, this.selectedValue);
      this.loadInspectionResults(this.currentSearchFilters);
      this.selectValue=false;
      this.filteredEquipments=[];
      this.numberofselectedEquipments=0;
      this.EquipmentRanges=[];
    });

}

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
}

//equipment select
numberofselectedEquipments:number=0;
filteredEquipments:EquipmentForSelectionVM[]=[];

selectedEquipmentList:EquipmentForSelectionVM[]=[];
selectedEquipmenetIds:number[]=[];
toggleSelectAllEquipment(){
  this.selectAllEquipments =!this.selectAllEquipments;
  
  if(this.selectAllEquipments){
    this.numberofselectedEquipments=this.equipmentInspectionResults.length;
    this.selectValue=true;
   
    this.selecetedLevel=1;
    this.selectedValue=0;
     this.GetRangeFromDB(100, 100);
    if(this.equipmentInspectionResults.length>0){
      this.equipmentInspectionResults.map(x=>{
        x.select=true;
        this.selectedEquipmenetIds.push(x.EquipmentId);
      })
    }
    this.filteredEquipments = this.equipmentInspectionResults;
  }else{
    this.selectValue=false;
    this.IsDefault=false;
    this.numberofselectedEquipments=0;
    if(this.equipmentInspectionResults.length>0){
      this.equipmentInspectionResults.map(x=>{
        x.select=false;
      
      })
    }
    this.filteredEquipments = [];
    this.selectedEquipmenetIds=[];
  }
}
toggleEqSelect(selectEq:EquipmentForSelectionVM){
    selectEq.select = !selectEq.select;
    console.log("toggle select", selectEq);
    if(selectEq.select==true){
      this.filteredEquipments.push(selectEq);
    }else{
     this.filteredEquipments = this.filteredEquipments.filter(x=>x.select==true);
    }
    if(this.filteredEquipments.length>0){
      this.selectValue=true;
      this.selecetedLevel=1;
      this.selectedValue=0;
      
    }
   this.numberofselectedEquipments = this.filteredEquipments.length;
   if(this.numberofselectedEquipments==1){
      this._evalService.GetSelectedLevelRangesForSelectedEquipment(this.filteredEquipments[0].EquipmentId).subscribe(res=>{
        console.log("result", res);
        this.selectedEquipmenetIds.push(this.filteredEquipments[0].EquipmentId);
        this.CustomSelectRanges =res;
        this.SetCustomRangetoComponents(this.CustomSelectRanges)
        if(this.CustomSelectRanges.IsDefault){
          this.IsDefault=true;
          this.A_to=30
          this.B_from=">"+30;
          this.B_to=50;
          this.C_from=">"+50
          this.C_to=70
         this.X_from=">"+70
          //this.SetCustomRangetoComponents(this.CustomSelectRanges)
        }else{
          this.IsDefault=false;
          this.A_to=null;
          this.B_from="";
          this.B_to=null;
          this.C_from="";
          this.C_to=null;
         this.X_from="";
        }
      })
    
    
    }else if(this.numberofselectedEquipments>1){
    this.GetRangeFromDB(this.selecetedLevel, 100);
    this.filteredEquipments.map(r=>{
      this.selectedEquipmenetIds.push(r.EquipmentId);
    })
   }
   else if(this.numberofselectedEquipments==0){
    this.selectValue=false;
    this.selectedEquipmenetIds=[];
   }
    console.log("selectelist", this.filteredEquipments);
}
//Default and General___
ChangeExcludeC(){
this.isCExclude = !this.isCExclude;
if(this.isCExclude){
  this.X_from = ">"+ this.B_to;
  this.C_from ="";
  this.C_to=null;
}else{
  this.X_from = "";
  this.C_from = ">"+this.B_to;
  this.C_to=null;
}
}
Add_A_to(event:any){
  this.A_to = event.target.value;
  if(this.A_to<0){
    this.InValid=true;
  }else{
    this.InValid=false;
    this.B_from = ">" +  this.A_to;
  }
  
}

Add_B_to(event:any){
  this.B_to = event.target.value;
  if(this.B_to <= this.A_to){
    this.InValid=true;
  }else{
    this.InValid=false;

    if(!this.isCExclude){
      this.C_from = ">" +this.B_to;
    }else{
      this.C_from ="";
      this.X_from = ">" + this.B_to;
    }
  }
  
}
Add_C_to(event:any){
  this.C_to = event.target.value;
  if(this.C_to <= this.B_to){
    this.InValid=true;
  }else{
    this.InValid=false;
    this.X_from = ">" + this.C_to
  }
  
}



//LINK
ChangeExcludeC_Link(){
  this.ChangeExcludeC_LinkC = !this.ChangeExcludeC_LinkC;
  this.isCExclude_Link = !this.isCExclude_Link;
  if(this.isCExclude_Link){
    this.LinkX_from = ">"+ this.LinkB_to;
    this.LinkC_from ="";
    this.LinkC_to=null;
  }else{
    this.LinkX_from = "";
    this.LinkC_from = ">"+this.LinkB_to;
    this.LinkC_to=null;
  }
  }
  Add_Link_A_to(event:any){
    this.LinkA_to = event.target.value;
    if(this.LinkA_to<0){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.LinkB_from = ">" +  this.LinkA_to;
    }
    
  }
  
  Add_Link_B_to(event:any){
    this.LinkB_to = event.target.value;
    if(this.LinkB_to <= this.LinkA_to){
      this.InValid=true;
    }else{
      this.InValid=false;
  
      if(!this.isCExclude_Link){
        this.LinkC_from = ">" +this.LinkB_to;
      }else{
        this.LinkC_from ="";
        this.LinkX_from = ">" + this.LinkB_to;
      }
    }
    
  }
  Add_Link_C_to(event:any){
    this.LinkC_to = event.target.value;
    if(this.LinkC_to <= this.LinkB_to){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.LinkX_from = ">" + this.LinkC_to
    }
    
  }
  

  //Bush
ChangeExcludeC_Bush(){
  this.ChangeExcludeC_BushC = !this.ChangeExcludeC_BushC;
  this.isCExclude_Bush = !this.isCExclude_Bush;
  if(this.isCExclude_Bush){
    this.BushX_from = ">"+ this.BushB_to;
    this.BushC_from ="";
    this.BushC_to=null;
  }else{
    this.BushX_from = "";
    this.BushC_from = ">"+this.BushB_to;
    this.BushC_to=null;
  }
  }
  Add_Bush_A_to(event:any){
    this.BushA_to = event.target.value;
    if(this.BushA_to<0){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.BushB_from = ">" +  this.BushA_to;
    }
    
  }
  
  Add_Bush_B_to(event:any){
    this.BushB_to = event.target.value;
    if(this.BushB_to <= this.BushA_to){
      this.InValid=true;
    }else{
      this.InValid=false;
  
      if(!this.isCExclude_Bush){
        this.BushC_from = ">" +this.BushB_to;
      }else{
        this.BushC_from ="";
        this.BushX_from = ">" + this.BushB_to;
      }
    }
    
  }
  Add_Bush_C_to(event:any){
    this.BushC_to = event.target.value;
    if(this.BushC_to <= this.BushB_to){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.BushX_from = ">" + this.BushC_to
    }
    
  }

  //Shoe
ChangeExcludeC_Shoe(){
  this.ChangeExcludeC_ShoeC = !this.ChangeExcludeC_ShoeC;
  this.isCExclude_Shoe = !this.isCExclude_Shoe;
  if(this.isCExclude_Shoe){
    this.ShoeX_from = ">"+ this.ShoeB_to;
    this.ShoeC_from ="";
    this.ShoeC_to=null;
  }else{
    this.ShoeX_from = "";
    this.ShoeC_from = ">"+this.ShoeB_to;
    this.ShoeC_to=null;
  }
  }
  Add_Shoe_A_to(event:any){
    this.ShoeA_to = event.target.value;
    if(this.ShoeA_to<0){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.ShoeB_from = ">" +  this.ShoeA_to;
    }
    
  }
  
  Add_Shoe_B_to(event:any){
    this.ShoeB_to = event.target.value;
    if(this.ShoeB_to <= this.ShoeA_to){
      this.InValid=true;
    }else{
      this.InValid=false;
  
      if(!this.isCExclude_Shoe){
        this.ShoeC_from = ">" +this.ShoeB_to;
      }else{
        this.ShoeC_from ="";
        this.ShoeX_from = ">" + this.ShoeB_to;
      }
    }
    
  }
  Add_Shoe_C_to(event:any){
    this.ShoeC_to = event.target.value;
    if(this.ShoeC_to <= this.ShoeB_to){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.ShoeX_from = ">" + this.ShoeC_to
    }
    
  }


  //Sprocket
ChangeExcludeC_Sprocket(){
  this.ChangeExcludeC_SprocketC = !this.ChangeExcludeC_SprocketC;
  this.isCExclude_Sprocket = !this.isCExclude_Sprocket;
  if(this.isCExclude_Sprocket){
    this.SprocketX_from = ">"+ this.SprocketB_to;
    this.SprocketC_from ="";
    this.SprocketC_to=null;
  }else{
    this.SprocketX_from = "";
    this.SprocketC_from = ">"+this.SprocketB_to;
    this.SprocketC_to=null;
  }
  }
  Add_Sprocket_A_to(event:any){
    this.SprocketA_to = event.target.value;
    if(this.SprocketA_to<0){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.SprocketB_from = ">" +  this.SprocketA_to;
    }
    
  }
  
  Add_Sprocket_B_to(event:any){
    this.SprocketB_to = event.target.value;
    if(this.SprocketB_to <= this.SprocketA_to){
      this.InValid=true;
    }else{
      this.InValid=false;
  
      if(!this.isCExclude_Sprocket){
        this.SprocketC_from = ">" +this.SprocketB_to;
      }else{
        this.SprocketC_from ="";
        this.SprocketX_from = ">" + this.SprocketB_to;
      }
    }
    
  }
  Add_Sprocket_C_to(event:any){
    this.SprocketC_to = event.target.value;
    if(this.SprocketC_to <= this.SprocketB_to){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.SprocketX_from = ">" + this.SprocketC_to
    }
    
  }

  //Idler
ChangeExcludeC_Idler(){
  this.ChangeExcludeC_IdlerC = !this.ChangeExcludeC_IdlerC;
  this.isCExclude_Idler = !this.isCExclude_Idler;
  if(this.isCExclude_Idler){
    this.IdlerX_from = ">"+ this.IdlerB_to;
    this.IdlerC_from ="";
    this.IdlerC_to=null;
  }else{
    this.IdlerX_from = "";
    this.IdlerC_from = ">"+this.IdlerB_to;
    this.IdlerC_to=null;
  }
  }
  Add_Idler_A_to(event:any){
    this.IdlerA_to = event.target.value;
    if(this.IdlerA_to<0){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.IdlerB_from = ">" +  this.IdlerA_to;
    }
    
  }
  
  Add_Idler_B_to(event:any){
    this.IdlerB_to = event.target.value;
    if(this.IdlerB_to <= this.IdlerA_to){
      this.InValid=true;
    }else{
      this.InValid=false;
  
      if(!this.isCExclude_Idler){
        this.IdlerC_from = ">" +this.IdlerB_to;
      }else{
        this.IdlerC_from ="";
        this.IdlerX_from = ">" + this.IdlerB_to;
      }
    }
    
  }
  Add_Idler_C_to(event:any){
    this.IdlerC_to = event.target.value;
    if(this.IdlerC_to <= this.IdlerB_to){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.IdlerX_from = ">" + this.IdlerC_to
    }
    
  }

  //TrackRoller
ChangeExcludeC_TrackRoller(){
  this.ChangeExcludeC_TrackRollerC = !this.ChangeExcludeC_TrackRollerC;
  this.isCExclude_TrackRoller = !this.isCExclude_TrackRoller;
  if(this.isCExclude_TrackRoller){
    this.TrackRollerX_from = ">"+ this.TrackRollerB_to;
    this.TrackRollerC_from ="";
    this.TrackRollerC_to=null;
  }else{
    this.TrackRollerX_from = "";
    this.TrackRollerC_from = ">"+this.TrackRollerB_to;
    this.TrackRollerC_to=null;
  }
  }
  Add_TrackRoller_A_to(event:any){
    this.TrackRollerA_to = event.target.value;
    if(this.TrackRollerA_to<0){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.TrackRollerB_from = ">" +  this.TrackRollerA_to;
    }
    
  }
  
  Add_TrackRoller_B_to(event:any){
    this.TrackRollerB_to = event.target.value;
    if(this.TrackRollerB_to <= this.TrackRollerA_to){
      this.InValid=true;
    }else{
      this.InValid=false;
  
      if(!this.isCExclude_TrackRoller){
        this.TrackRollerC_from = ">" +this.TrackRollerB_to;
      }else{
        this.TrackRollerC_from ="";
        this.TrackRollerX_from = ">" + this.TrackRollerB_to;
      }
    }
    
  }
  Add_TrackRoller_C_to(event:any){
    this.TrackRollerC_to = event.target.value;
    if(this.TrackRollerC_to <= this.TrackRollerB_to){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.TrackRollerX_from = ">" + this.TrackRollerC_to
    }
    
  }

  //CarrierRoller
ChangeExcludeC_CarrierRoller(){
  this.ChangeExcludeC_CarrierRollerC = !this.ChangeExcludeC_CarrierRollerC;
  this.isCExclude_CarrierRoller = !this.isCExclude_CarrierRoller;
  if(this.isCExclude_CarrierRoller){
    this.CarrierRollerX_from = ">"+ this.CarrierRollerB_to;
    this.CarrierRollerC_from ="";
    this.CarrierRollerC_to=null;
  }else{
    this.CarrierRollerX_from = "";
    this.CarrierRollerC_from = ">"+this.CarrierRollerB_to;
    this.CarrierRollerC_to=null;
  }
  }
  Add_CarrierRoller_A_to(event:any){
    this.CarrierRollerA_to = event.target.value;
    if(this.CarrierRollerA_to<0){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.CarrierRollerB_from = ">" +  this.CarrierRollerA_to;
    }
    
  }
  
  Add_CarrierRoller_B_to(event:any){
    this.CarrierRollerB_to = event.target.value;
    if(this.CarrierRollerB_to <= this.CarrierRollerA_to){
      this.InValid=true;
    }else{
      this.InValid=false;
  
      if(!this.isCExclude_CarrierRoller){
        this.CarrierRollerC_from = ">" +this.CarrierRollerB_to;
      }else{
        this.CarrierRollerC_from ="";
        this.CarrierRollerX_from = ">" + this.CarrierRollerB_to;
      }
    }
    
  }
  Add_CarrierRoller_C_to(event:any){
    this.CarrierRollerC_to = event.target.value;
    if(this.CarrierRollerC_to <= this.CarrierRollerB_to){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.CarrierRollerX_from = ">" + this.CarrierRollerC_to
    }
    
  }

  //RSRearIdler
ChangeExcludeC_RSRearIdler(){
  this.ChangeExcludeC_RSRearIdlerC = !this.ChangeExcludeC_RSRearIdlerC;
  this.isCExclude_RSRearIdler = !this.isCExclude_RSRearIdler;
  if(this.isCExclude_RSRearIdler){
    this.RSRearIdlerX_from = ">"+ this.RSRearIdlerB_to;
    this.RSRearIdlerC_from ="";
    this.RSRearIdlerC_to=null;
  }else{
    this.RSRearIdlerX_from = "";
    this.RSRearIdlerC_from = ">"+this.RSRearIdlerB_to;
    this.RSRearIdlerC_to=null;
  }
  }
  Add_RSRearIdler_A_to(event:any){
    this.RSRearIdlerA_to = event.target.value;
    if(this.RSRearIdlerA_to<0){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.RSRearIdlerB_from = ">" +  this.RSRearIdlerA_to;
    }
    
  }
  
  Add_RSRearIdler_B_to(event:any){
    this.RSRearIdlerB_to = event.target.value;
    if(this.RSRearIdlerB_to <= this.RSRearIdlerA_to){
      this.InValid=true;
    }else{
      this.InValid=false;
  
      if(!this.isCExclude_RSRearIdler){
        this.RSRearIdlerC_from = ">" +this.RSRearIdlerB_to;
      }else{
        this.RSRearIdlerC_from ="";
        this.RSRearIdlerX_from = ">" + this.RSRearIdlerB_to;
      }
    }
    
  }
  Add_RSRearIdler_C_to(event:any){
    this.RSRearIdlerC_to = event.target.value;
    if(this.RSRearIdlerC_to <= this.RSRearIdlerB_to){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.RSRearIdlerX_from = ">" + this.RSRearIdlerC_to
    }
    
  }

//CrawlerGuide
ChangeExcludeC_CrawlerGuide(){
  this.ChangeExcludeC_CrawlerGuideC = !this.ChangeExcludeC_CrawlerGuideC;
  this.isCExclude_CrawlerGuide = !this.isCExclude_CrawlerGuide;
  if(this.isCExclude_CrawlerGuide){
    this.CrawlerGuideX_from = ">"+ this.CrawlerGuideB_to;
    this.CrawlerGuideC_from ="";
    this.CrawlerGuideC_to=null;
  }else{
    this.CrawlerGuideX_from = "";
    this.CrawlerGuideC_from = ">"+this.CrawlerGuideB_to;
    this.CrawlerGuideC_to=null;
  }
  }
  Add_CrawlerGuide_A_to(event:any){
    this.CrawlerGuideA_to = event.target.value;
    if(this.CrawlerGuideA_to<0){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.CrawlerGuideB_from = ">" +  this.CrawlerGuideA_to;
    }
    
  }
  
  Add_CrawlerGuide_B_to(event:any){
    this.CrawlerGuideB_to = event.target.value;
    if(this.CrawlerGuideB_to <= this.CrawlerGuideA_to){
      this.InValid=true;
    }else{
      this.InValid=false;
  
      if(!this.isCExclude_CrawlerGuide){
        this.CrawlerGuideC_from = ">" +this.CrawlerGuideB_to;
      }else{
        this.CrawlerGuideC_from ="";
        this.CrawlerGuideX_from = ">" + this.CrawlerGuideB_to;
      }
    }
    
  }
  Add_CrawlerGuide_C_to(event:any){
    this.CrawlerGuideC_to = event.target.value;
    if(this.CrawlerGuideC_to <= this.CrawlerGuideB_to){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.CrawlerGuideX_from = ">" + this.CrawlerGuideC_to
    }
    
  }


  //Elongation
ChangeExcludeC_Elongation(){
  this.ChangeExcludeC_ElongationC = !this.ChangeExcludeC_ElongationC;
  this.isCExclude_Elongation = !this.isCExclude_Elongation;
  if(this.isCExclude_Elongation){
    this.ElongationX_from = ">"+ this.ElongationB_to;
    this.ElongationC_from ="";
    this.ElongationC_to=null;
  }else{
    this.ElongationX_from = "";
    this.ElongationC_from = ">"+this.ElongationB_to;
    this.ElongationC_to=null;
  }
  }
  Add_Elongation_A_to(event:any){
    this.ElongationA_to = event.target.value;
    if(this.ElongationA_to<0){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.ElongationB_from = ">" +  this.ElongationA_to;
    }
    
  }
  
  Add_Elongation_B_to(event:any){
    this.ElongationB_to = event.target.value;
    if(this.ElongationB_to <= this.ElongationA_to){
      this.InValid=true;
    }else{
      this.InValid=false;
  
      if(!this.isCExclude_Elongation){
        this.ElongationC_from = ">" +this.ElongationB_to;
      }else{
        this.ElongationC_from ="";
        this.ElongationX_from = ">" + this.ElongationB_to;
      }
    }
    
  }
  Add_Elongation_C_to(event:any){
    this.ElongationC_to = event.target.value;
    if(this.ElongationC_to <= this.ElongationB_to){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.ElongationX_from = ">" + this.ElongationC_to
    }
    
  }

  //General
ChangeExcludeC_General(){
  this.ChangeExcludeC_GeneralC = !this.ChangeExcludeC_GeneralC;
  this.isCExclude_General = !this.isCExclude_General;
  if(this.isCExclude_General){
    this.GeneralX_from = ">"+ this.GeneralB_to;
    this.GeneralC_from ="";
    this.GeneralC_to=null;
  }else{
    this.GeneralX_from = "";
    this.GeneralC_from = ">"+this.GeneralB_to;
    this.GeneralC_to=null;
  }
  }
  Add_General_A_to(event:any){
    this.GeneralA_to = event.target.value;
    if(this.GeneralA_to<0){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.GeneralB_from = ">" +  this.GeneralA_to;
    }
    
  }
  
  Add_General_B_to(event:any){
    this.GeneralB_to = event.target.value;
    if(this.GeneralB_to <= this.GeneralA_to){
      this.InValid=true;
    }else{
      this.InValid=false;
  
      if(!this.isCExclude_General){
        this.GeneralC_from = ">" +this.GeneralB_to;
      }else{
        this.GeneralC_from ="";
        this.GeneralX_from = ">" + this.GeneralB_to;
      }
    }
    
  }
  Add_General_C_to(event:any){
    this.GeneralC_to = event.target.value;
    if(this.GeneralC_to <= this.GeneralB_to){
      this.InValid=true;
    }else{
      this.InValid=false;
      this.GeneralX_from = ">" + this.GeneralC_to
    }
    
  }


LoadEvaluationLevels(){
  this._evalService.GetCustomEvaluationLevels().subscribe(res=>{
    console.log("Levels", res)
    this.EvalLevels = res;
  })
}

isJobsiteLevelSelect:boolean=false;
FilterLevelData(event:any){
 this.FiteredList=[];
 this.CurrentSelectLevelForRange = 0;
 this.selectedCustomerId = 0;
  console.log("event", event)
  if (event.value.Id > 0 && event.value != null) {
    this.isLevelSelect = true;
    this.selectValue=false;
let selectedLevel = event.value.Id


switch (selectedLevel) {
  case 4:
    //if(this.hasDealers){
      {
        this.isJobsiteLevelSelect = false;
        console.log("CurrentSelectLevelForRange", this.CurrentSelectLevelForRange)

      this.isEquipmentLevelSelect=false;
      this.CurrentSelectLevelForRange = 0;
      this.levelName = "Select Dealer"
      this.LoadAccessibleDealers();
      break;
    }
   
  case 3: //if(this.hasCustomers){
    
  {
    this.isJobsiteLevelSelect = false;

    this.CurrentSelectLevelForRange = 0;
    this.isEquipmentLevelSelect=false;
    this.levelName = "Select Customer"
    this.LoadAccessibleCustomers();
    break;
  }
  case 2:
    {//if(this.hasJobsites){
      this.isJobsiteLevelSelect = true;
      this.CurrentSelectLevelForRange = 0;
    this.isEquipmentLevelSelect=false;
    this.levelName = "Select Jobsite"
    this.LoadAccessibleCustomers();
    this.LoadAccessibleJobsites();
    break;
  }
  case 1:
    this.isJobsiteLevelSelect = false;

    //this.levelName = "Select Equipment"
    //this.LoadAccessibleEquipments();
    this.CurrentSelectLevelForRange = 0;
    this.selectValue=false;
    this.isLevelSelect = false;
    this.isEquipmentLevelSelect=true;
    break;
  
    
}
    
  }
  else {
    this.CurrentSelectLevelForRange = 0;
    this.isEquipmentLevelSelect=false;
    this.isLevelSelect = false;
  }

}

ReSetCustomRangetoComponents_ForSpecific_CompTypes(range:CustomeEvaluationRangeVM,type:string){
  if(type=="Link"){
    this.LinkA_to=range.LinkA;
    this.LinkB_from=">"+range.LinkA;
    this.LinkB_to=range.LinkB;
    this.LinkC_from= range.LinkC !=null?">"+range.LinkB:"";
    this.LinkC_to=range.LinkC !=null?range.LinkC:null;
    this.LinkX_from=range.LinkC !=null?">" +range.LinkC:">"+range.LinkB;
    this.ChangeExcludeC_LinkC = range.LinkC!=null?false:true;
    this.isCExclude_Link = range.LinkC!=null?false:true;
  }
  if(type=="Bush"){
    this.BushA_to=range.BushA;
    this.BushB_from=">"+range.BushA;
    this.BushB_to=range.BushB;
    this.BushC_from= range.BushC !=null?">"+range.BushB:"";
    this.BushC_to=range.BushC !=null?range.BushC:null;
    this.BushX_from=range.BushC !=null?">" +range.BushC:">"+range.BushB;
    this.ChangeExcludeC_BushC = range.BushC!=null?false:true;
    this.isCExclude_Bush = range.BushC!=null?false:true;
  
  }

  if(type=="Shoe"){
    this.ShoeA_to=range.ShoeA
    this.ShoeB_from=">"+range.ShoeA
    this.ShoeB_to=range.ShoeB
    this.ShoeC_from= range.ShoeC !=null?">"+range.ShoeB:"";
    this.ShoeC_to=range.ShoeC !=null?range.ShoeC:null;
    this.ShoeX_from=range.ShoeC !=null?">" +range.ShoeC:">"+range.ShoeB;
    this.ChangeExcludeC_ShoeC = range.ShoeC!=null?false:true;
    this.isCExclude_Shoe = range.ShoeC!=null?false:true;
  
  }

  if(type=="Sprocket"){
    this.SprocketA_to=range.SprocketA
    this.SprocketB_from=">"+range.SprocketA
    this.SprocketB_to=range.SprocketB
    this.SprocketC_from= range.SprocketC !=null?">"+range.SprocketB:"";
    this.SprocketC_to=range.SprocketC !=null?range.SprocketC:null;
    this.SprocketX_from=range.SprocketC !=null?">" +range.SprocketC:">"+range.SprocketB;
    this.ChangeExcludeC_SprocketC = range.SprocketC!=null?false:true;
    this.isCExclude_Sprocket = range.SprocketC!=null?false:true;
  
  }
  
  if(type=="Idler"){
    this.IdlerA_to=range.IdlerA
  this.IdlerB_from=">"+range.IdlerA
  this.IdlerB_to=range.IdlerB
  this.IdlerC_from= range.IdlerC !=null?">"+range.IdlerB:"";
  this.IdlerC_to=range.IdlerC !=null?range.IdlerC:null;
  this.IdlerX_from=range.IdlerC !=null?">" +range.IdlerC:">"+range.IdlerB;
  this.ChangeExcludeC_IdlerC = range.IdlerC!=null?false:true;
  this.isCExclude_Idler= range.IdlerC!=null?false:true;
  }
  
  if(type=="TrackRoller"){
    this.TrackRollerA_to=range.TrackRollerA
    this.TrackRollerB_from=">"+range.TrackRollerA
    this.TrackRollerB_to=range.TrackRollerB
    this.TrackRollerC_from= range.TrackRollerC !=null?">"+range.TrackRollerB:"";
    this.TrackRollerC_to=range.TrackRollerC !=null?range.TrackRollerC:null;
    this.TrackRollerX_from=range.TrackRollerC !=null?">" +range.TrackRollerC:">"+range.TrackRollerB;
    this.ChangeExcludeC_TrackRollerC = range.TrackRollerC!=null?false:true;
    this.isCExclude_TrackRoller= range.TrackRollerC!=null?false:true;
  }

  

  if(type=="CarrierRoller"){
    this.CarrierRollerA_to=range.CarrierRollerA
  this.CarrierRollerB_from=">"+range.CarrierRollerA
  this.CarrierRollerB_to=range.CarrierRollerB
  this.CarrierRollerC_from= range.CarrierRollerC !=null?">"+range.CarrierRollerB:"";
  this.CarrierRollerC_to=range.CarrierRollerC !=null?range.CarrierRollerC:null;
  this.CarrierRollerX_from=range.CarrierRollerC !=null?">" +range.CarrierRollerC:">"+range.CarrierRollerB;
  this.ChangeExcludeC_CarrierRollerC = range.CarrierRollerC!=null?false:true;
  this.isCExclude_CarrierRoller= range.CarrierRollerC!=null?false:true;
  }


  if(type=="RSRearIdler"){
    this.RSRearIdlerA_to=range.RSRearIdlerA
  this.RSRearIdlerB_from=">"+range.RSRearIdlerA
  this.RSRearIdlerB_to=range.RSRearIdlerB
  this.RSRearIdlerC_from= range.RSRearIdlerC !=null?">"+range.RSRearIdlerB:"";
  this.RSRearIdlerC_to=range.RSRearIdlerC !=null?range.RSRearIdlerC:null;
  this.RSRearIdlerX_from=range.RSRearIdlerC !=null?">" +range.RSRearIdlerC:">"+range.RSRearIdlerB;
  this.ChangeExcludeC_RSRearIdlerC = range.RSRearIdlerC!=null?false:true;
  this.isCExclude_RSRearIdler= range.RSRearIdlerC!=null?false:true;
  }
  if(type=="CrawlerGuide"){
    this.CrawlerGuideA_to=range.CrawlerGuideA
  this.CrawlerGuideB_from=">"+range.CrawlerGuideA
  this.CrawlerGuideB_to=range.CrawlerGuideB
  this.CrawlerGuideC_from= range.CrawlerGuideC !=null?">"+range.CrawlerGuideB:"";
  this.CrawlerGuideC_to=range.CrawlerGuideC !=null?range.CrawlerGuideC:null;
  this.CrawlerGuideX_from=range.CrawlerGuideC !=null?">" +range.CrawlerGuideC:">"+range.CrawlerGuideB;
  this.ChangeExcludeC_CrawlerGuideC = range.CrawlerGuideC!=null?false:true;
  this.isCExclude_CrawlerGuide= range.CrawlerGuideC!=null?false:true;
  }



  if(type=="Elongation"){
    this.ElongationA_to=range.ElongationA
  this.ElongationB_from=">"+range.ElongationA
  this.ElongationB_to=range.ElongationB
  this.ElongationC_from= range.ElongationC !=null?">"+range.ElongationB:"";
  this.ElongationC_to=range.ElongationC !=null?range.ElongationC:null;
  this.ElongationX_from=range.ElongationC !=null?">" +range.ElongationC:">"+range.ElongationB;
  this.ChangeExcludeC_ElongationC = range.ElongationC!=null?false:true;
  this.isCExclude_Elongation= range.ElongationC!=null?false:true;
  }


  if(type=="General"){
    this.GeneralA_to=range.GeneralA
    this.GeneralB_from=">"+range.GeneralA
    this.GeneralB_to=range.GeneralB
    this.GeneralC_from= range.GeneralC !=null?">"+range.GeneralB:"";
    this.GeneralC_to=range.GeneralC !=null?range.GeneralC:null;
    this.GeneralX_from=range.GeneralC !=null?">" +range.GeneralC:">"+range.GeneralB;
    this.ChangeExcludeC_GeneralC = range.GeneralC!=null?false:true;
    this.isCExclude_General= range.GeneralC!=null?false:true;
  
  }

  

}

SetCustomRangetoComponents(range:CustomeEvaluationRangeVM){
  this.LinkA_to=range.LinkA;
  this.LinkB_from=">"+range.LinkA;
  this.LinkB_to=range.LinkB;
  this.LinkC_from= range.LinkC !=null?">"+range.LinkB:"";
  this.LinkC_to=range.LinkC !=null?range.LinkC:null;
  this.LinkX_from=range.LinkC !=null?">" +range.LinkC:">"+range.LinkB;
  this.ChangeExcludeC_LinkC = range.LinkC!=null?false:true;
  this.isCExclude_Link = range.LinkC!=null?false:true;

  this.BushA_to=range.BushA;
  this.BushB_from=">"+range.BushA;
  this.BushB_to=range.BushB;
  this.BushC_from= range.BushC !=null?">"+range.BushB:"";
  this.BushC_to=range.BushC !=null?range.BushC:null;
  this.BushX_from=range.BushC !=null?">" +range.BushC:">"+range.BushB;
  this.ChangeExcludeC_BushC = range.BushC!=null?false:true;
  this.isCExclude_Bush = range.BushC!=null?false:true;


  this.ShoeA_to=range.ShoeA
  this.ShoeB_from=">"+range.ShoeA
  this.ShoeB_to=range.ShoeB
  this.ShoeC_from= range.ShoeC !=null?">"+range.ShoeB:"";
  this.ShoeC_to=range.ShoeC !=null?range.ShoeC:null;
  this.ShoeX_from=range.ShoeC !=null?">" +range.ShoeC:">"+range.ShoeB;
  this.ChangeExcludeC_ShoeC = range.ShoeC!=null?false:true;
  this.isCExclude_Shoe = range.ShoeC!=null?false:true;
  

  this.SprocketA_to=range.SprocketA
  this.SprocketB_from=">"+range.SprocketA
  this.SprocketB_to=range.SprocketB
  this.SprocketC_from= range.SprocketC !=null?">"+range.SprocketB:"";
  this.SprocketC_to=range.SprocketC !=null?range.SprocketC:null;
  this.SprocketX_from=range.SprocketC !=null?">" +range.SprocketC:">"+range.SprocketB;
  this.ChangeExcludeC_SprocketC = range.SprocketC!=null?false:true;
  this.isCExclude_Sprocket = range.SprocketC!=null?false:true;


  this.IdlerA_to=range.IdlerA
  this.IdlerB_from=">"+range.IdlerA
  this.IdlerB_to=range.IdlerB
  this.IdlerC_from= range.IdlerC !=null?">"+range.IdlerB:"";
  this.IdlerC_to=range.IdlerC !=null?range.IdlerC:null;
  this.IdlerX_from=range.IdlerC !=null?">" +range.IdlerC:">"+range.IdlerB;
  this.ChangeExcludeC_IdlerC = range.IdlerC!=null?false:true;
  this.isCExclude_Idler= range.IdlerC!=null?false:true;


  this.TrackRollerA_to=range.TrackRollerA
  this.TrackRollerB_from=">"+range.TrackRollerA
  this.TrackRollerB_to=range.TrackRollerB
  this.TrackRollerC_from= range.TrackRollerC !=null?">"+range.TrackRollerB:"";
  this.TrackRollerC_to=range.TrackRollerC !=null?range.TrackRollerC:null;
  this.TrackRollerX_from=range.TrackRollerC !=null?">" +range.TrackRollerC:">"+range.TrackRollerB;
  this.ChangeExcludeC_TrackRollerC = range.TrackRollerC!=null?false:true;
  this.isCExclude_TrackRoller= range.TrackRollerC!=null?false:true;



  this.CarrierRollerA_to=range.CarrierRollerA
  this.CarrierRollerB_from=">"+range.CarrierRollerA
  this.CarrierRollerB_to=range.CarrierRollerB
  this.CarrierRollerC_from= range.CarrierRollerC !=null?">"+range.CarrierRollerB:"";
  this.CarrierRollerC_to=range.CarrierRollerC !=null?range.CarrierRollerC:null;
  this.CarrierRollerX_from=range.CarrierRollerC !=null?">" +range.CarrierRollerC:">"+range.CarrierRollerB;
  this.ChangeExcludeC_CarrierRollerC = range.CarrierRollerC!=null?false:true;
  this.isCExclude_CarrierRoller= range.CarrierRollerC!=null?false:true;



  this.RSRearIdlerA_to=range.RSRearIdlerA
  this.RSRearIdlerB_from=">"+range.RSRearIdlerA
  this.RSRearIdlerB_to=range.RSRearIdlerB
  this.RSRearIdlerC_from= range.RSRearIdlerC !=null?">"+range.RSRearIdlerB:"";
  this.RSRearIdlerC_to=range.RSRearIdlerC !=null?range.RSRearIdlerC:null;
  this.RSRearIdlerX_from=range.RSRearIdlerC !=null?">" +range.RSRearIdlerC:">"+range.RSRearIdlerB;
  this.ChangeExcludeC_RSRearIdlerC = range.RSRearIdlerC!=null?false:true;
  this.isCExclude_RSRearIdler= range.RSRearIdlerC!=null?false:true;



  this.CrawlerGuideA_to=range.CrawlerGuideA
  this.CrawlerGuideB_from=">"+range.CrawlerGuideA
  this.CrawlerGuideB_to=range.CrawlerGuideB
  this.CrawlerGuideC_from= range.CrawlerGuideC !=null?">"+range.CrawlerGuideB:"";
  this.CrawlerGuideC_to=range.CrawlerGuideC !=null?range.CrawlerGuideC:null;
  this.CrawlerGuideX_from=range.CrawlerGuideC !=null?">" +range.CrawlerGuideC:">"+range.CrawlerGuideB;
  this.ChangeExcludeC_CrawlerGuideC = range.CrawlerGuideC!=null?false:true;
  this.isCExclude_CrawlerGuide= range.CrawlerGuideC!=null?false:true;



  this.ElongationA_to=range.ElongationA
  this.ElongationB_from=">"+range.ElongationA
  this.ElongationB_to=range.ElongationB
  this.ElongationC_from= range.ElongationC !=null?">"+range.ElongationB:"";
  this.ElongationC_to=range.ElongationC !=null?range.ElongationC:null;
  this.ElongationX_from=range.ElongationC !=null?">" +range.ElongationC:">"+range.ElongationB;
  this.ChangeExcludeC_ElongationC = range.ElongationC!=null?false:true;
  this.isCExclude_Elongation= range.ElongationC!=null?false:true;


  this.GeneralA_to=range.GeneralA
  this.GeneralB_from=">"+range.GeneralA
  this.GeneralB_to=range.GeneralB
  this.GeneralC_from= range.GeneralC !=null?">"+range.GeneralB:"";
  this.GeneralC_to=range.GeneralC !=null?range.GeneralC:null;
  this.GeneralX_from=range.GeneralC !=null?">" +range.GeneralC:">"+range.GeneralB;
  this.ChangeExcludeC_GeneralC = range.GeneralC!=null?false:true;
  this.isCExclude_General= range.GeneralC!=null?false:true;

this.saving=false;
this.applytoall=false;

}

GetEvaluationRange(event:any){
  console.log("Select Range data", event)
  this.selectedValue = event.value.Id;
  this.selecetedLevel=event.value.LevelId;
  this.selectValue=true;

this.GetRangeFromDB(this.selecetedLevel, this.selectedValue);
}

CurrentSelectLevelForRange :number = 0;
GetRangeFromDB(level:number,value:number){
  this._evalService.GetSelectedLevelRanges(this.selecetedLevel,this.selectedValue).subscribe(res=>{
    console.log("selectedRange___", res)
    this.CustomSelectRanges =res;
    this.SetCustomRangetoComponents(this.CustomSelectRanges)
    if(this.CustomSelectRanges.IsDefault){
      this.IsDefault=true;
      this.A_to=30
      this.B_from=">"+30;
      this.B_to=50;
      this.C_from=">"+50
      this.C_to=70
     this.X_from=">"+70
      //this.SetCustomRangetoComponents(this.CustomSelectRanges)
    }else{
      this.IsDefault=false;
      this.A_to=null;
      this.B_from="";
      this.B_to=null;
      this.C_from="";
      this.C_to=null;
     this.X_from="";
     this.CurrentSelectLevelForRange = this.CustomSelectRanges.LevelId;
    }
    
  })
}

OpenDeleteConfirmation() {
  const dialogRef = this._dialog.open(ConfirmationBoxComponent, {
    width: '400px',
    disableClose: true,
    data: {
      title: 'Delete',
      message: 'Are you sure you want to delete the evaluation range?',
      button1: 'Yes'
    }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result?.confirmed) {
      this.DeleteRange();
    }
  });
}


DeleteRange(){
  if(!this.isEquipmentLevelSelect){
    this.filteredEquipments=[];
    this.numberofselectedEquipments=0;
    this.EquipmentRanges=[];
    this._evalService.DeleteSelectedLevelRanges(this.selecetedLevel,this.selectedValue).subscribe(res=>{
      console.log("Deletede", res)
      if(res.m_Item1==true){ 
        this.GetRangeFromDB(this.selecetedLevel, this.selectedValue);
        this._notification.success('Deleted', "Sucessfully deleted the evaluation range");
        
      }else{
        this._notification.error('Failed', "Delete evaluation range");
      }
    })
  }else{
    this.filteredEquipments.map(x=>{
      if(x.LevelId==1){
        var m= new EquipmentRanges();
        m.equipmentId=x.EquipmentId;
        m.level=x.LevelId;
        x.isDeleted=true;
        this.EquipmentRanges.push(m);
      }else{
         x.isDeleted=false;
      }
      
    })
    this.selectedEquipmentList = this.filteredEquipments.filter(x=>x.LevelId!=1);
    console.log("this.EquipmentRanges;", this.EquipmentRanges, this.selectedEquipmentList)
    if(this.EquipmentRanges.length>0){
      this._evalService.DeleteSelectedLevelRanges_Equipment(this.EquipmentRanges).subscribe(res=>{
        console.log("resul_", res)
        if(res.m_Item1==true){ 
          this._notification.success('Deleted', "Sucessfully deleted the evaluation range");
          
        }else{
         
          this._notification.error('Failed', "Delete evaluation range");
        }
      });
    }
    
   
    if(this.selectedEquipmentList.length>0)
    this.OpenDeleteEquipmentConfirm();
  }
}

SaveorUpdate(){
  this.saving=true;
  console.log("SelectedData", this.selectedValue, this.selecetedLevel) ;
  var range = new  CustomeEvaluationRangeVM();
  range.LinkA = this.LinkA_to;
  range.LinkB= this.LinkB_to;
  range.LinkC=this.LinkC_to;
  
  range.BushA = this.BushA_to;
  range.BushB= this.BushB_to;
  range.BushC=this.BushC_to;

  range.ShoeA = this.ShoeA_to;
  range.ShoeB= this.ShoeB_to;
  range.ShoeC=this.ShoeC_to;

  range.SprocketA = this.SprocketA_to;
  range.SprocketB= this.SprocketB_to;
  range.SprocketC=this.SprocketC_to;

  range.IdlerA = this.IdlerA_to;
  range.IdlerB= this.IdlerB_to;
  range.IdlerC=this.IdlerC_to;

  range.TrackRollerA = this.TrackRollerA_to;
  range.TrackRollerB= this.TrackRollerB_to;
  range.TrackRollerC=this.TrackRollerC_to;

  range.CarrierRollerA = this.CarrierRollerA_to;
  range.CarrierRollerB= this.CarrierRollerB_to;
  range.CarrierRollerC=this.CarrierRollerC_to;

  range.RSRearIdlerA = this.RSRearIdlerA_to;
  range.RSRearIdlerB= this.RSRearIdlerB_to;
  range.RSRearIdlerC=this.RSRearIdlerC_to;

  range.CrawlerGuideA = this.CrawlerGuideA_to;
  range.CrawlerGuideB= this.CrawlerGuideB_to;
  range.CrawlerGuideC=this.CrawlerGuideC_to;

  range.ElongationA = this.ElongationA_to;
  range.ElongationB= this.ElongationB_to;
  range.ElongationC=this.ElongationC_to;

  range.GeneralA = this.GeneralA_to;
  range.GeneralB= this.GeneralB_to;
  range.GeneralC=this.GeneralC_to;

  range.LevelId=this.selecetedLevel;
  if(!this.isEquipmentLevelSelect)
  range.SelectedValue = this.selectedValue;
  else
  range.SelectedValueList = this.selectedEquipmenetIds;


  this._evalService.updateRangetoSelectedComponents(range).subscribe(res=>{
    
    console.log("res", res)
    if(res.m_Item1==true){ 
      this.GetRangeFromDB(this.selecetedLevel, this.selectedValue);
      this._notification.success('Saved', "Sucessfully updated Evaluation Ranges");
      if(this.isEquipmentLevelSelect){
        this.loadInspectionResults(this.currentSearchFilters);
        this.selectValue=false;
        this.filteredEquipments=[];
        this.numberofselectedEquipments=0;
      }
      
    }else{
      this._notification.error('Failed', "Update Evaluation Ranges");
    }
  })
}
saving:boolean=false;
applytoall:boolean=false;
ApplytoAllComp(){

  this.applytoall=true;


  if(this.isEquipmentLevelSelect==false){
    var model = new  ApplyToAllCompsVm();
    model.A = this.A_to;
    model.B=this.B_to;
    model.C=this.C_to;
    model.LevelId=this.selecetedLevel;
    model.Value=this.selectedValue;
    this._evalService.SetRangetoAllComponents(model).subscribe(res=>{
     
      console.log("save data", res);
      if(res.m_Item1==true){ 
        this.GetRangeFromDB(this.selecetedLevel, this.selectedValue);
        this._notification.success('Saved', "Apply to all components");
        
      }else{
        this._notification.error('Failed', "Apply to all components");
      }
     
    })
  }

  else{
    var model_ = new  ApplyToAllCompsEquipmentsVm();
    model_.A = this.A_to;
    model_.B=this.B_to;
    model_.C=this.C_to;
    model_.LevelId=1;
    model_.Value=this.selectedEquipmenetIds;
    this._evalService.SetRangetoAllComponentsForSelectedEquipments(model_).subscribe(res=>{
     
      console.log("save data___", res);
      if(res.m_Item1==true){ 
        this.GetRangeFromDB(this.selecetedLevel, this.selectedValue);
        this._notification.success('Saved', "Apply to all components");
        this.loadInspectionResults(this.currentSearchFilters);
        this.selectValue=false;
        this.filteredEquipments=[];
        this.numberofselectedEquipments=0;
        

        
      }else{
        this._notification.error('Failed', "Apply to all components");
      }
     
    })
  }
  
}

ResetComponentRange(type:string){
  if(this.IsDefault){
    if(type=="Link"){
      this.LinkA_to=30;
      this.LinkB_from=">"+30;
      this.LinkB_to=50;
      this.LinkC_from= ">"+50;
      this.LinkC_to=70;
      this.LinkX_from=">" +70
      this.ChangeExcludeC_LinkC =false;
      this.isCExclude_Link = false;
    }
    if(type=="Bush"){
      this.BushA_to=30;
      this.BushB_from=">"+30;
      this.BushB_to=50;
      this.BushC_from= ">"+50;
      this.BushC_to=70;
      this.BushX_from=">" +70
      this.ChangeExcludeC_BushC =false;
      this.isCExclude_Bush = false;
    }
    if(type=="Shoe")
    {
      this.ShoeA_to=30;
      this.ShoeB_from=">"+30;
      this.ShoeB_to=50;
      this.ShoeC_from= ">"+50;
      this.ShoeC_to=70;
      this.ShoeX_from=">" +70
      this.ChangeExcludeC_ShoeC =false;
      this.isCExclude_Shoe = false;
  }
  if(type=="Sprocket")
  {
  this.SprocketA_to=30;
  this.SprocketB_from=">"+30;
  this.SprocketB_to=50;
  this.SprocketC_from= ">"+50;
  this.SprocketC_to=70;
  this.SprocketX_from=">" +70
  this.ChangeExcludeC_SprocketC =false;
  this.isCExclude_Sprocket = false;
  }
  if(type=="Idler")
  {
    this.IdlerA_to=30;
    this.IdlerB_from=">"+30;
    this.IdlerB_to=50;
    this.IdlerC_from= ">"+50;
    this.IdlerC_to=70;
    this.IdlerX_from=">" +70
    this.ChangeExcludeC_IdlerC =false;
    this.isCExclude_Idler = false;
  }
  if(type=="TrackRoller"){
    this.TrackRollerA_to=30;
      this.TrackRollerB_from=">"+30;
      this.TrackRollerB_to=50;
      this.TrackRollerC_from= ">"+50;
      this.TrackRollerC_to=70;
      this.TrackRollerX_from=">" +70
      this.ChangeExcludeC_TrackRollerC =false;
      this.isCExclude_TrackRoller = false;
  }
  if(type=="CarrierRoller"){
    this.CarrierRollerA_to=30;
      this.CarrierRollerB_from=">"+30;
      this.CarrierRollerB_to=50;
      this.CarrierRollerC_from= ">"+50;
      this.CarrierRollerC_to=70;
      this.CarrierRollerX_from=">" +70
      this.ChangeExcludeC_CarrierRollerC =false;
      this.isCExclude_CarrierRoller = false;
  }
  if(type=="RSRearIdler"){
    this.RSRearIdlerA_to=30;
      this.RSRearIdlerB_from=">"+30;
      this.RSRearIdlerB_to=50;
      this.RSRearIdlerC_from= ">"+50;
      this.RSRearIdlerC_to=70;
      this.RSRearIdlerX_from=">" +70
      this.ChangeExcludeC_RSRearIdlerC =false;
      this.isCExclude_RSRearIdler = false;
  }

  if(type=="CrawlerGuide"){
    this.CrawlerGuideA_to=30;
    this.CrawlerGuideB_from=">"+30;
    this.CrawlerGuideB_to=50;
    this.CrawlerGuideC_from= ">"+50;
    this.CrawlerGuideC_to=70;
    this.CrawlerGuideX_from=">" +70
    this.ChangeExcludeC_CrawlerGuideC =false;
    this.isCExclude_CrawlerGuide = false;
  } 
  if(type=="Elongation"){
    this.ElongationA_to=30;
      this.ElongationB_from=">"+30;
      this.ElongationB_to=50;
      this.ElongationC_from= ">"+50;
      this.ElongationC_to=70;
      this.ElongationX_from=">" +70
      this.ChangeExcludeC_ElongationC =false;
      this.isCExclude_Elongation = false;
  }
  if(type=="General"){
    this.GeneralA_to=30;
    this.GeneralB_from=">"+30;
    this.GeneralB_to=50;
    this.GeneralC_from= ">"+50;
    this.GeneralC_to=70;
    this.GeneralX_from=">" +70
    this.ChangeExcludeC_GeneralC =false;
    this.isCExclude_General = false;
  }

}
else{
  // this._evalService.GetSelectedLevelRanges(this.selecetedLevel,this.selectedValue).subscribe(res=>{
  //   console.log("selectedRange___", res)
  //   this.CustomSelectRanges =res;
   
    
  //   });
    this.ReSetCustomRangetoComponents_ForSpecific_CompTypes(this.CustomSelectRanges,type);
}
}
translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
}
Translate(value: string): string {
  return this._translate.translateToLang(value, this.userLanguage);
}

LoadAccessibleDealers(){
  this._evalService.GetDelaersForUser().subscribe(res=>{
    console.log("Dealers", res)
    this.FiteredList =res;
  })
}

LoadAccessibleCustomers(){
  this._evalService.GetCustomersForUser().subscribe(res=>{
    console.log("Customers", res)
    if(this.isJobsiteLevelSelect==true)
    this.FiteredCustomerList = res;
    else
    this.FiteredList  =res;
  })
}

selectedCustomerId:number=0;
GetJobsiteForCustomer(event:any){
  this.selectedCustomerId = event.value.Id
  this.selectedValue = 0;
  this.selectValue=false;
  this.LoadAccessibleJobsites();
}

LoadAccessibleJobsites(){
  this._evalService.GetJobsitesForUser().subscribe(res=>{
    this.FiteredList  =res;
    if(this.selectedCustomerId>0){
      this.FiteredList = this.FiteredList.filter(x=>x.customerId == this.selectedCustomerId);
    }
  })
  
}

LoadAccessibleEquipments(){
  this._evalService.GetEquipmentsForUser().subscribe(res=>{
   
    this.FiteredList  =res;
  })
}


setVisibleComponentsForUser() {
  this.hasDealers = this.checkAccess(UserAccessType.GlobalAdministrator, 'Administrator', true) ||
                                this.checkAccess(UserAccessType.DealershipAdministrator, 'Administrator', true);
  this.hasJobsites = this.checkAccess(UserAccessType.GlobalAdministrator, 'Administrator', true) ||
                            this.checkAccess(UserAccessType.DealershipAdministrator, 'Administrator', true) ||
                            this.checkAccess(UserAccessType.CustomerAdministrator, 'Administrator', true) ||
                            this.checkAccess(UserAccessType.DealershipUser, 'Administrator', true);
  this.hasCustomers = this.checkAccess(UserAccessType.GlobalAdministrator, 'Administrator', true) ||
                            this.checkAccess(UserAccessType.DealershipAdministrator, 'Administrator', true) ||
                            this.checkAccess(UserAccessType.DealershipUser, 'Administrator', true);
}

checkAccess(accessCategory: UserAccessType, JobRole: string, JobRoleCheck: boolean): boolean {
  if (JobRoleCheck && !this._currentUserJobRoles.find(m => m === JobRole)) { return false; }
  if (this.userAccessType === accessCategory) { return true; }
  return false;
}



//Equipment search


  currentSearchFilters: SearchItem[] = [];


  public pageNumber = 0;
  public inspectionsPerPage = 25;
  public totalResults = 0;
  public inspectionResults: number[] = [];
  public equipmentInspectionResults: EquipmentForSelectionVM[] = [];
  public retrievingInspectionResults = true;

  private subscriptions: Subscription[] = [];
  private lastItemsSearched: SearchItem[] = [];


  
  /**
   * Unsubscribe from all our subscriptions before leaving
   * the page. 
   */
  ngOnDestroy() {
    this.subscriptions.forEach(
      subscription => {
        if (!subscription.closed) subscription.unsubscribe();
      });
  }

  /**
   * Initializes the subscription to the shared search
   * component. Will pre-set the initial selected search filters
   * to whatever the last shared search was in the app state. 
   */
  initializeSearch() {
    this.currentSearchFilters = this._appService.getLastSelectionSearchItems();
    this.subscriptions.push(
      this._appService.getSelectionSearchItems().subscribe(
        searchItems => {
          this.currentSearchFilters = searchItems;
          this.loadInspectionResults(searchItems);
          })
    );
  }

  loading:boolean=false;
  public loadInspectionResults(params: SearchItem[]) {
    this.retrievingInspectionResults = true;
    this.lastItemsSearched = params;

   
    this.loading=true;
    this.subscriptions.push(this._evalService.GetAllEquipmentforSelection(params)
      .subscribe(
      results => {
        this.equipmentInspectionResults=results;
        
        this.loading=false;
      },
      error => {
        console.log(error);
        this._notification.error('Error', 'Unable to search for Equipements. Please contact TrackTreads support if this error continues to happen. ');
      },
      () => {
        this.retrievingInspectionResults = false;
      })
    );
  }
}
